import React from "react";
import {
  Row,
  Col,
  Checkbox,
  InputNumber,
  Button,
  Space,
  List,
  Typography,
  Grid,
} from "antd";

const { Text, Title } = Typography;
const { useBreakpoint } = Grid;

const CartItem = ({
  cartId,
  item,
  isChecked,
  handleCheckboxChange,
  handleQuantityChange,
  handleRemove,
  cart,
}) => {
  const screens = useBreakpoint();

  return (
    <List.Item
      style={{
        padding: screens.xs ? "12px 8px" : "16px",
        borderBottom: "1px solid #f0f0f0",
      }}
    >
      <Row style={{ width: "100%" }} align="middle" gutter={[12, 12]}>
        {/* Checkbox */}
        <Col flex="none">
          <Checkbox
            checked={isChecked(cartId, item.product._id)}
            onChange={(e) =>
              handleCheckboxChange(cartId, item.product._id, e.target.checked)
            }
          />
        </Col>

        {/* Product Image - Responsive size based on viewport */}
        <Col xs={6} sm={4} md={3} style={{ textAlign: "center" }}>
          <img
            src={`${item.product.images}?v=${item.product.imageVersion}`}
            alt={item.product.name}
            style={{
              width: "100%",
              maxWidth: screens.xs ? "80px" : "120px",
              height: screens.xs ? "80px" : "120px",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        </Col>

        {/* Product Details */}
        <Col xs={14} sm={12} md={13}>
          <Space direction="vertical" size={2} style={{ width: "100%" }}>
            <Title
              level={5}
              style={{
                margin: 0,
                fontSize: screens.xs ? "14px" : "16px",
                lineHeight: "1.3",
              }}
            >
              {item.product.name}
            </Title>
            <Text type="secondary" style={{ fontSize: "14px" }}>
              Price:{" "}
              <Text strong type="danger">
                ${Number(item.product.price).toFixed(2)}
              </Text>
            </Text>

            {/* Quantity Selector Inline */}
            <Row align="middle" gutter={8} style={{ marginTop: "6px" }}>
              <Col flex="none">
                <Text style={{ fontSize: "12px" }}>Qty:</Text>
              </Col>
              <Col flex="none">
                <InputNumber
                  min={1}
                  size={screens.xs ? "small" : "middle"}
                  value={item.quantity}
                  onChange={(value) =>
                    handleQuantityChange(cartId, item.product._id, value)
                  }
                />
              </Col>
            </Row>
          </Space>
        </Col>

        {/* Actions - Remove Button */}
        <Col
          xs={24}
          sm={4}
          md={4}
          style={{
            textAlign: screens.xs ? "right" : "center",
            marginTop: screens.xs ? "4px" : "0",
          }}
        >
          {cart.items.length > 1 && (
            <Button
              danger
              type={screens.xs ? "text" : "default"}
              size={screens.xs ? "small" : "middle"}
              onClick={() => handleRemove(cartId, item.product._id)}
            >
              Remove
            </Button>
          )}
        </Col>
      </Row>
    </List.Item>
  );
};

export default CartItem;
